<template>
   <div class="text-input">
      <label ><b>Default Freight</b></label>
      <div class="row p-0 m-0 justify-content-between">
        <div class="col-4 p-0 m-0">
          <select class="form-control select-percent"
              v-model="isDefaultFreightPercent"
              @change="updateIsDefaultFreightPercent"
              >
                <option :value="true">%</option>
                <option :value="false">$</option>
            </select>
        </div>
        <div class="col-7 p-0 m-0">
          <div class="input-group">
            <input type='text' class="form-control" v-model="displayValue" :disabled="disabled" @blur="updating=false" @focus="updating=true" aria-label="Default Freight">
            <!-- <input type='text' class="form-control" :disabled="disabled" v-model="displayValue" @focus="updating=true" @blur="updating=false" :aria-label="{label}"> -->
          </div>
          <div v-if="validator && validator.$error && validator.$dirty">
            <div class="error" v-for="(key, index) in Object.keys(validator.$params)" :key="key + index" >
              <div class="p-0 m-0" v-if="!validator[key]">{{ validatorMsgMap[key] }}</div>
            </div>
          </div>
        </div>
      </div>
   </div>
</template> 

<script>
export default {
  name: "PercentInput",
  props: {
     percentInput: {
        type: Boolean,
        default: true,
     },
     placeholder: {
        type: String,
     },
     disabled: {
        type: Boolean,
        default: false,
     },
     value: {
        type: [String, Number],
     },
     customStyles: {
         type: Object,
     },
     validatorMsgMap: {
         type: Object,
         default: null,
     },
     validator: {
         type: Object,
         default: null,
     }
  },
  data(){
    return{
      updating: false,
      isDefaultFreightPercent: null,
    }
  },
  methods: {
    updateIsDefaultFreightPercent(){
      this.$emit('isDefaultFreightPercentChanged', this.isDefaultFreightPercent)
    },
    getIfPercent(){
      if (!this.value) return;
      if (this.updating) {
        // Cursor is inside the input field. unformat display value for user
        return this.value.toString()
      } else {
        // User is not modifying now. Format display value for user interface
        return this.value.toFixed(2)+ " %"
      }
    },
    setIfPercent(modifiedValue){
      // Recalculate value after ignoring "$" and "," in user input
      let newValue = parseFloat(modifiedValue.replace(/[^\d\.]/g, ""));
      if(newValue > 100){
        newValue = 100;
      }
      // Ensure that it is not NaN
      if (isNaN(newValue)) {
          newValue = null
      }
      // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
      // $emit the event so that parent component gets it
      this.$emit('input', newValue);
    },
    getIfAmount(){
      if (this.updating) {
        // Cursor is inside the input field. unformat display value for user
        if(this.value === null || this.value === undefined) return null
        return this.value.toString()
      } else {
        // User is not modifying now. Format display value for user interface
        if (this.value === null || this.value === undefined) return null
        return "$ " + this.value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
      }
    },
    setIfAmount(modifiedValue){
      // Recalculate value after ignoring "$" and "," in user input
      let newValue = parseFloat(modifiedValue.replace(/[^\d\.]/g, ""));
      // Ensure that it is not NaN
      if (isNaN(newValue)) {
          newValue = null
      }
      // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
      // $emit the event so that parent component gets it
      this.$emit('input', newValue);
    }
  },
  computed: {
    displayValue: {
      get: function() {
        return this.percentInput ? this.getIfPercent() : this.getIfAmount()
        
      },
      set: function(modifiedValue) {
        return this.percentInput ? this.setIfPercent(modifiedValue) : this.setIfAmount(modifiedValue)
      }
    }
  },
  watch: {
    percentInput: function(){
      this.isDefaultFreightPercent = this.percentInput
    }
  },
  created(){
    this.isDefaultFreightPercent = this.percentInput
  }
}
</script>

<style lang="scss" scoped>
  .select-percent{
    padding-left: 10px;
    padding-right: 0px;
  }
  .toggle-label{
    cursor: pointer;
    .toggle-on{
      color: $primary
    }
    .toggle-off{
      color: $secondary
    }
  }
  
</style>